import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import LanguageDriverServices from "services/LanguageDriverServices";
import { notifyError, notifySuccess } from "utils/toast";

const useLanguageDriver = (id) => {
 
   
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();





  const onSubmit = async (data) => {
 setLoading(true);
   // console.log('suganya arun',data);
    try {
      setIsSubmitting(true);
     
     // console.log("LanguageDriverData:", LanguageDriverData);
      const LanguageDriverData = {
        lang_driver:data.lang_driver,
       
       
        };

      if (id) {

        const res = await LanguageDriverServices.updateLanguageDriver(id, LanguageDriverData);
        
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await LanguageDriverServices.addLanguageDriver( LanguageDriverData );
 

        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
  
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };
 // console.log(res);
  const getLanguageDriverData = async () => {

    try {
      const res = await LanguageDriverServices.getLanguageDriverById(id);
      if (res) {
    
    
        setValue("lang_driver", res.data.lang_driver);
    
  
     
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  
  };

  useEffect(() => {
    if (!isDrawerOpen) {
    
      setValue("lang_driver");
    
     
      clearErrors();
      return;
    }
      
    if (id) {
      getLanguageDriverData();
    }
    // eslint-disable-next-line
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isSubmitting,

    loading,setLoading,
  
 
  };
};  

export default useLanguageDriver;
